<template>
    <div class="tab-panel">
        <div class="row">
            <div class="col-6">
                <notes :canAdd="false"></notes>
            </div>

            <div class="col-6">
                <div class="panel pax">
                    <h5 class="d-flex">
                        <div>Check-in</div>
                        <div class="ml-auto fs-small bold">Total: {{ paxTotal }}</div>
                    </h5>   

                    <div>
                        <div class="d-flex align-items-center mb-2">
                            <span class="mr-auto">Check-in</span>
                            <calculator @mathDone="mathDone" :object="reservation" field="paxCheckedIn" :max="reservation.paxTotal"></calculator>
                        </div>

                        <div class="d-flex align-items-center mb-2">
                            <span class="mr-auto">No-show</span>
                            <calculator @mathDone="mathDone" :object="reservation" field="paxNoShow" :max="reservation.paxTotal"></calculator>
                        </div>

                        <button class="d-flex ml-auto btn wide" @click="checkAll">Check All</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Notes from '../Notes'
    import Calculator from '../Calculator'

    export default {
        mixins: [reservationsMixin],
        data: function() {
            return {
                reservation: null,
            }
        },
        created: function() {
            this.reservation = JSON.parse(JSON.stringify(this.getClonedReservation));
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'account',
            ]),
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            mathDone: function(data) {
                let sum = -1;

                // Make sure we're updating values within range. We must test the combined
                // total for paxCheckedIn and paxNoShow together

                if (data.field === 'paxCheckedIn') {
                    sum = this.reservation.paxTotal - data.value - this.reservation.paxNoShow;
                }
                else if (data.field === 'paxNoShow') {
                    sum = this.reservation.paxTotal - this.reservation.paxCheckedIn - data.value;
                }

                if (sum >= 0) {
                    this.$set(this.reservation, data.field, data.value);
                    this.updateClonedReservation(this.reservation);
                }
            },
            checkAll: function() {
                this.$set(this.reservation, 'paxCheckedIn', this.reservation.paxTotal);
                this.$set(this.reservation, 'paxNoShow', 0);
            },
        },
        components: {
            Notes,
            Calculator,
        }
    }
</script>




// WEBPACK FOOTER //
// ViewOverview.vue?0817b2c1